export type Language = "ro" | "en";

export const translations = {
  nav: {
    home: { ro: "Acasă", en: "Home" },
    about: { ro: "Despre Noi", en: "About Us" },
    equipment: { ro: "Echipamente", en: "Equipment" },
    injectionMachines: { ro: "Mașini de Injecție", en: "Injection Machines" },
    robots: { ro: "Roboți", en: "Robots" },
    auxiliaries: { ro: "Auxiliare", en: "Auxiliaries" },
    centralSystems: { ro: "Sisteme Centralizate", en: "Central Systems" },
    contact: { ro: "Contact", en: "Contact" },
    promotions: { ro: "Promoții", en: "Promotions" },
  },
  promotions: {
    title: { ro: "Promoții", en: "Promotions" },
    subtitle: {
      ro: "Oferte speciale pentru piese de schimb și echipamente",
      en: "Special offers on spare parts and equipment",
    },
    spareParts: { ro: "Piese de Schimb", en: "Spare Parts" },
    sparePartsDesc: {
      ro: "Oferte speciale la piese de schimb originale WITTMANN pentru întreținerea și repararea echipamentelor.",
      en: "Special offers on original WITTMANN spare parts for equipment maintenance and repair.",
    },
    equipment: { ro: "Echipamente", en: "Equipment" },
    equipmentDesc: {
      ro: "Promoții la echipamente WITTMANN selecționate — mașini de injecție, roboți și auxiliare.",
      en: "Promotions on selected WITTMANN equipment — injection machines, robots, and auxiliaries.",
    },
    explore: { ro: "Vezi Ofertele", en: "View Offers" },
    comingSoon: { ro: "Ofertele vor fi disponibile în curând.", en: "Offers will be available soon." },
  },
  home: {
    heroTitle: {
      ro: "WITTMANN ROMANIA",
      en: "WITTMANN ROMANIA",
    },
    heroSubtitle: {
      ro: "Soluții complete pentru industria de prelucrare a maselor plastice",
      en: "Complete solutions for the plastics processing industry",
    },
    heroProducts: {
      ro: "Mașini de injecție, Roboți, Termoregulatoare, Uscătoare, Sisteme Centralizate",
      en: "Injection Machines, Robots, Temperature Controllers, Dryers, Central Systems",
    },
    heroCta: { ro: "Descoperiți Echipamentele", en: "Discover Equipment" },
    heroContact: { ro: "Contactați-ne", en: "Contact Us" },
    sectionEquipment: { ro: "Echipamentele Noastre", en: "Our Equipment" },
    sectionEquipmentDesc: {
      ro: "Oferim o gamă completă de echipamente pentru industria maselor plastice",
      en: "We offer a complete range of equipment for the plastics industry",
    },
    whyUs: { ro: "De Ce WITTMANN?", en: "Why WITTMANN?" },
    whyExperience: { ro: "Experiență", en: "Experience" },
    whyExperienceDesc: {
      ro: "Peste 45 de ani de inovație în industria maselor plastice",
      en: "Over 45 years of innovation in the plastics industry",
    },
    whyQuality: { ro: "Calitate", en: "Quality" },
    whyQualityDesc: {
      ro: "Standarde europene de calitate și fiabilitate recunoscute mondial",
      en: "European quality and reliability standards recognized worldwide",
    },
    whySupport: { ro: "Suport Local", en: "Local Support" },
    whySupportDesc: {
      ro: "Echipă dedicată de service și suport tehnic în România",
      en: "Dedicated service and technical support team in Romania",
    },
    whyIntegration: { ro: "Integrare 4.0", en: "Integration 4.0" },
    whyIntegrationDesc: {
      ro: "Soluții complete Industry 4.0 pentru fabrica inteligentă",
      en: "Complete Industry 4.0 solutions for the smart factory",
    },
  },
  about: {
    title: { ro: "Despre Noi", en: "About Us" },
    subtitle: {
      ro: "WITTMANN ROMANIA - Partenerul dumneavoastră de încredere",
      en: "WITTMANN ROMANIA - Your trusted partner",
    },
    p1: {
      ro: "WITTMANN ROMANIA este reprezentanța oficială a grupului WITTMANN în România, oferind soluții complete pentru industria de prelucrare a maselor plastice. Cu o experiență vastă și o echipă de specialiști dedicați, suntem partenerul ideal pentru companiile care doresc echipamente de înaltă calitate.",
      en: "WITTMANN ROMANIA is the official representative of the WITTMANN Group in Romania, offering complete solutions for the plastics processing industry. With extensive experience and a team of dedicated specialists, we are the ideal partner for companies seeking high-quality equipment.",
    },
    p2: {
      ro: "Grupul WITTMANN, cu sediul central în Viena, Austria, este unul dintre liderii mondiali în producția de echipamente pentru industria maselor plastice. Portofoliul nostru include mașini de injecție, roboți, echipamente auxiliare și sisteme centralizate de ultimă generație.",
      en: "The WITTMANN Group, headquartered in Vienna, Austria, is one of the world leaders in the production of equipment for the plastics industry. Our portfolio includes injection molding machines, robots, auxiliary equipment, and state-of-the-art central systems.",
    },
    p3: {
      ro: "Ne dedicăm furnizării de soluții personalizate care răspund nevoilor specifice ale clienților noștri din România și din regiune, oferind servicii de vânzare, instalare, punere în funcțiune și service post-vânzare.",
      en: "We are dedicated to providing customized solutions that meet the specific needs of our customers in Romania and the region, offering sales, installation, commissioning, and after-sales service.",
    },
    teamTitle: { ro: "Echipa", en: "Team" },
    missionTitle: { ro: "Misiunea Noastră", en: "Our Mission" },
    missionDesc: {
      ro: "Să oferim soluții inovatoare și eficiente pentru industria maselor plastice din România, contribuind la creșterea competitivității clienților noștri pe piața globală.",
      en: "To provide innovative and efficient solutions for the plastics industry in Romania, contributing to the growth of our customers' competitiveness in the global market.",
    },
  },
  equipment: {
    title: { ro: "Echipamente", en: "Equipment" },
    subtitle: {
      ro: "Gamă completă de echipamente pentru industria maselor plastice",
      en: "Complete range of equipment for the plastics industry",
    },
    explore: { ro: "Explorează", en: "Explore" },
    injectionDesc: {
      ro: "Mașini de injecție de înaltă performanță cu forțe de strângere de la 15 la 2.200 de tone.",
      en: "High-performance injection molding machines with clamping forces from 15 to 2,200 tons.",
    },
    robotsDesc: {
      ro: "Roboți și sisteme de automatizare pentru extragerea pieselor și operații post-procesare.",
      en: "Robots and automation systems for part removal and post-processing operations.",
    },
    auxiliariesDesc: {
      ro: "Echipamente auxiliare: uscătoare, regulatoare de temperatură, dozatoare și granulatoare.",
      en: "Auxiliary equipment: dryers, temperature controllers, dosing units, and granulators.",
    },
    centralDesc: {
      ro: "Sisteme centralizate de transport, uscare și dozare a materialelor plastice.",
      en: "Central systems for conveying, drying, and dosing of plastic materials.",
    },
    backToEquipment: { ro: "← Înapoi la Echipamente", en: "← Back to Equipment" },
    viewGrid: { ro: "Grilă", en: "Grid" },
    viewList: { ro: "Listă", en: "List" },
    viewDetails: { ro: "Vezi Detalii", en: "View Details" },
    allTypes: { ro: "Toate", en: "All" },
    electric: { ro: "Electric", en: "Electric" },
    servoHydraulic: { ro: "Servo-Hidraulic", en: "Servo-Hydraulic" },
    servoDrive: { ro: "Servo Drive", en: "Servo Drive" },
    noProducts: { ro: "Produsele vor fi adăugate în curând.", en: "Products will be added soon." },
  },
  contact: {
    title: { ro: "Contact", en: "Contact" },
    subtitle: {
      ro: "Suntem aici pentru dumneavoastră",
      en: "We are here for you",
    },
    address: { ro: "Adresă", en: "Address" },
    phone: { ro: "Telefon", en: "Phone" },
    email: { ro: "Email", en: "Email" },
    formQuote: { ro: "Solicitare Ofertă", en: "Request Quote" },
    formService: { ro: "Cerere Intervenție", en: "Service Request" },
    name: { ro: "Nume", en: "Name" },
    company: { ro: "Companie", en: "Company" },
    emailField: { ro: "Email", en: "Email" },
    phoneField: { ro: "Telefon", en: "Phone" },
    message: { ro: "Mesaj", en: "Message" },
    equipmentType: { ro: "Tip Echipament", en: "Equipment Type" },
    machineModel: { ro: "Model Mașină", en: "Machine Model" },
    equipmentSerial: { ro: "Serie Echipament", en: "Equipment Serial" },
    urgency: { ro: "Urgență", en: "Urgency" },
    urgencyLow: { ro: "Scăzută", en: "Low" },
    urgencyMedium: { ro: "Medie", en: "Medium" },
    urgencyHigh: { ro: "Ridicată", en: "High" },
    problemDesc: { ro: "Descrierea Problemei", en: "Problem Description" },
    submit: { ro: "Trimite", en: "Submit" },
    successMessage: {
      ro: "Mesajul a fost trimis cu succes!",
      en: "Message sent successfully!",
    },
    errorMessage: {
      ro: "A apărut o eroare. Vă rugăm încercați din nou.",
      en: "An error occurred. Please try again.",
    },
    sending: {
      ro: "Se trimite...",
      en: "Sending...",
    },
    mapTitle: {
      ro: "Locațiile Noastre",
      en: "Our Locations",
    },
  },
  footer: {
    rights: {
      ro: "Toate drepturile rezervate.",
      en: "All rights reserved.",
    },
    description: {
      ro: "Reprezentanța oficială WITTMANN în România. Soluții complete pentru industria maselor plastice.",
      en: "Official WITTMANN representative in Romania. Complete solutions for the plastics industry.",
    },
    quickLinks: { ro: "Linkuri Rapide", en: "Quick Links" },
    contactInfo: { ro: "Informații Contact", en: "Contact Info" },
    emailSales: { ro: "Vânzări echipamente:", en: "Equipment sales:" },
    emailService: { ro: "Service/piese de schimb:", en: "Service/spare parts:" },
    emailEoat: { ro: "Elemente EOAT:", en: "EOAT elements:" },
  },
} as const;

export function t(
  key: string,
  lang: Language
): string {
  const keys = key.split(".");
  let value: any = translations;
  for (const k of keys) {
    value = value?.[k];
  }
  return value?.[lang] ?? key;
}
